const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

export function isUuid(value: string): boolean {
  return UUID_RE.test(value.trim());
}

export function minLength(value: string, n: number): boolean {
  return value.length >= n;
}

export function isValidPassword(value: string): boolean {
  return value.length >= 8;
}

export function passwordsMatch(password: string, confirmPassword: string): boolean {
  return password === confirmPassword && password.length > 0;
}

export function isValidName(value: string): boolean {
  return value.trim().length >= 2;
}
